<template>
  <div>
    <vxe-grid
      size="small"
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>

      <template v-slot:applyStatus="{ row }">
        <el-tag size="mini" :type="applyStatusTagType(row)">
          {{ row.applyStatusText || row.applyStatus }}
        </el-tag>
      </template>

      <template v-slot:inspectionResult="{ row }">
        <el-tag v-if="row.inspectionResult" size="mini" :type="inspectionResultTagType(row)">
          {{ row.inspectionResultText || row.inspectionResult}}
        </el-tag>
      </template>

      <template v-slot:urgencyLevel="{ row }">
        <el-tag size="mini" :type="urgencyLevelTagType(row)" effect="dark">
          {{ row.urgencyLevelText || row.urgencyLevel }}
        </el-tag>
      </template>

      <template v-slot:inspectionTime="{ row }">
        <div>
          <div>
            {{ row.inspectionStartTime }}
          </div>
          <div>
            {{ row.inspectionEndTime }}
          </div>
        </div>
      </template>

      <template v-slot:displayCreate="{ row }">
        <div>{{ row.createByName }}</div>
        <div>{{ row.createTime }}</div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import tableOpts from './table-opts'

export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true
      },
      tableColumns: tableColumns(this)
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    }
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { inspectionApplyCode, applyNo } = data
      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { code: inspectionApplyCode },
            query: { applyNo }
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'submit':
          this.submit(data)
          break
      }
    },
    // ApplyStatusEnum: 1-草稿 2-已提交 3-已排单 4-已完成 5-已删除
    applyStatusTagType({ applyStatus }) {
      const code = `${applyStatus || ''}`
      if (code === '5') return 'danger'
      if (code === '4') return 'success'
      if (code === '3') return 'warning'
      if (code === '2') return ''
      return 'info'
    },
    // ResultEnum: 1-NONE 2-PASS 3-PENDING 4-FAIL
    inspectionResultTagType({ inspectionResult }) {
      const code = `${inspectionResult || ''}`
      if (code === '4') return 'danger'
      if (code === '2') return 'success'
      if (code === '3') return 'warning'
      return 'info'
    },
    // UrgencyLevelEnum: 1-正常 2-重要 3-紧急
    urgencyLevelTagType({ urgencyLevel }) {
      const code = `${urgencyLevel || ''}`
      if (code === '3') return 'danger'
      if (code === '2') return 'warning'
      return 'info'
    },

    async del({ inspectionApplyCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_inspection_apply_delete_confirm') || '是否要删除该单据？',
        this.$l('dialog_title_confirm') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .dfInspectionApplyDelApi({ inspectionApplyCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, msg } = res
      if (status !== 200) {
        this.$message.error(
          msg || this.$l('tips_inspection_apply_delete_no') || '删除失败！'
        )
        return
      }
      this.$message({
        message: this.$l('tips_inspection_apply_delete_ok') || '删除成功！',
        type: 'success'
      })
      this.$emit('reload')
    },

    async submit({ inspectionApplyCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_inspection_apply_submit_confirm') ||
          '是否提交该验货需求？',
        this.$l('dialog_title_confirm') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .dfInspectionApplySubmitApi({ inspectionApplyCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, msg } = res
      if (status !== 200) {
        this.$message.error(
          msg || this.$l('tips_inspection_apply_submit_no') || '提交失败！'
        )
        return
      }
      this.$message({
        message: this.$l('tips_inspection_apply_submit_ok') || '提交成功！',
        type: 'success'
      })
      this.$emit('reload')
    }
  }
}
</script>
